module.exports = __webpack_public_path__ + "assets/img/e151efa9589a8e889d25f1e509aea038.png";